import { render } from "./PakcingHistory.vue?vue&type=template&id=1aa6bb91&scoped=true"
import script from "./PakcingHistory.vue?vue&type=script&lang=js"
export * from "./PakcingHistory.vue?vue&type=script&lang=js"

import "./PakcingHistory.vue?vue&type=style&index=0&id=1aa6bb91&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa6bb91"]])

export default __exports__